<template>
  <div>
    <div
      style="display: flex; justify-content: center; align-items: center"
      :style="'margin-top: ' + ui_setting.top3 + 'px'"
    >
    <div style="width: 33%;background-color: red:  !important; margin-right: 10px !important;">
        <table style="border-collapse: collapse; border: 1px solid black; width: 100%;">
          <tr>
            <td style="border: 1px solid black;">aa</td>
            <td style="border: 1px solid black;">dsfsdf</td>
            <td style="border: 1px solid black;">dsfsdf</td>
          </tr>
        </table>
      </div>
      <div style="width: 33%;background-color: red:  !important; margin-right: 10px !important;">
        <table style="border-collapse: collapse; border: 1px solid black; width: 100%;">
          <tr>
            <td style="border: 1px solid black;">aa</td>
            <td style="border: 1px solid black;">dsfsdf</td>
            <td style="border: 1px solid black;">dsfsdf</td>
          </tr>
        </table>
      </div>
      <div style="width: 33%;background-color: red:  !important;">
        <table style="border-collapse: collapse; border: 1px solid black; width: 100%;">
          <tr>
            <td style="border: 1px solid black;">aa</td>
            <td style="border: 1px solid black;">dsfsdf</td>
            <td style="border: 1px solid black;">dsfsdf</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");

import { mapState } from "vuex";
export default {
  data() {
    return {
      ui_setting: {},
    };
  },
  components: {
    ...mapState(["userProfile", "currentUser", "xxschoolPath"]),
  },
  created() {},

  props: {
    // student: {
    //   required: true,
    //   type: Object,
    // },
  },
};
</script>
 